import { render, staticRenderFns } from "./RefundView.vue?vue&type=template&id=b3bd0e50&scoped=true&"
import script from "./RefundView.vue?vue&type=script&lang=js&"
export * from "./RefundView.vue?vue&type=script&lang=js&"
import style0 from "./RefundView.vue?vue&type=style&index=0&id=b3bd0e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd0e50",
  null
  
)

export default component.exports